import React, { useState, useEffect } from "react";
import axios from "axios";

const MapComponent = ({ area, city, state, lat, lng }) => {
  const [position, setPosition] = useState(null);

  useEffect(() => {
    // If direct coordinates are provided, use them
    if (lat !== undefined && lng !== undefined) {
      setPosition([parseFloat(lat), parseFloat(lng)]);
      return;
    }
    
    // Otherwise, geocode the address
    const fetchData = async () => {
      try {
        // Only proceed if we have at least some address information
        if (!area && !city && !state) {
          console.log("No location information provided");
          return;
        }
        
        const address = `${area || ''}, ${city || ''}, ${state || ''}`;
        const response = await axios.get(
          `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(
            address
          )}&apiKey=66fb211605ce4df19efc87571b04001a`
        );

        // Extract the latitude and longitude from the response
        if (
          response.data &&
          response.data.features &&
          response.data.features.length > 0
        ) {
          const { lat, lon } = response.data.features[0].properties;
          setPosition([lat, lon]);
        }
      } catch (error) {
        console.error("Error fetching geocoded location:", error);
      }
    };

    fetchData();
  }, [area, city, state, lat, lng]);

  return (
    <div>
      {position && (
        <img
          alt="Map"
          src={`https://maps.geoapify.com/v1/staticmap?style=osm-carto&width=300&height=200&center=lonlat:${position[1]},${position[0]}&zoom=10&apiKey=66fb211605ce4df19efc87571b04001a`}
          style={{ width: "100%", height: "200px" }}
        />
      )}
    </div>
  );
};

export default MapComponent;
